<template>
  <div>
    <!-- Block -->
    <div class="block">
      <!-- table actions -->
      <div class="px-5 py-5">
        <!-- top search bar -->
        <div class="d-flex">
          <div class="form-input-group flex-grow-1 mr-5">
            <div class="prepend-icon" style="top: 45%;">
              <v-icon>search</v-icon>
            </div>
            <input
              type="text"
              class="pl-42px"
              placeholder="搜尋產品型號, Model Name, 產品序號"
              v-model="filter.keyword"
            />
          </div>
          <!--<SimpleSelectWithSearch-->
            <!--class="mr-5"-->
            <!--buttonWidth="150px"-->
            <!--buttonPlaceholder="篩選產品類別"-->
            <!--:selectedValue.sync="categoryOfPorductFilter"-->
            <!--:options="['Category1', 'Category2', 'Category3', 'Category11', '記憶體模組']"-->
          <!--&gt;</SimpleSelectWithSearch>-->
          <button class="btn btn-primary w-88px"
                  @click="getMemberProductRegistrations(member.id)">搜尋</button>
        </div>
      </div>

      <!-- table -->
      <div class="table">
        <div class="table-head">
          <!-- column head -->
          <div class="form-item d-flex px-5 h-60px align-center">
            <h5 class="col-icon"></h5>
            <h5 class="col-product">產品型號</h5>
            <h5 class="col-serial-number">產品序號</h5>
            <h5 class="col-date-of-purchase">購買日期</h5>
            <h5 class="col-date-of-register">註冊日期</h5>
          </div>
        </div>
        <div class="table-body">
          <TableCollapse
            v-for="item in productRegistrations"
            :key="item.id"
          >
            <!-- row 1 -->
            <template v-slot:head="slotProps">
              <div class="form-item d-flex h-60px align-center">
                <div class="h5 col-icon">
                  <v-icon color="ink-01-emphasis" v-if="!slotProps.isBodyShow"
                    >unfold_more</v-icon
                  >
                  <v-icon color="ink-01-emphasis" v-if="slotProps.isBodyShow"
                    >unfold_less</v-icon
                  >
                </div>
                <div class="h5 col-product">
                  <div class="mb-1">{{ item.model_name }}</div>
                  <div class="h6 ink-02-medium--text">
                    {{ item.type }} / {{ item.model_name }}
                  </div>
                </div>
                <div class="h5 col-serial-number">{{ item.sno }}</div>
                <div class="h5 col-date-of-purchase">
                  {{ item.purchased_date }}
                </div>
                <div class="h5 col-date-of-register">
                  {{ item.created_at }}
                </div>
              </div>
            </template>
            <!-- row 2 -->
            <template v-slot:body>
              <div class="form-item py-5" style="font-size: 14px;">
                <!-- 產品 -->
                <div class="d-flex pa-10px gray-100">
                  <h5 class="w-120px mr-10px">產品</h5>
                  <div class="flex-grow-1 flex-basis-0">
                    {{ item.model_name }}
                  </div>
                </div>
                <!-- 產品類別 -->
                <div class="d-flex pa-10px">
                  <h5 class="w-120px mr-10px">產品類別</h5>
                  <div class="flex-grow-1 flex-basis-0">
                    {{ item.type }}
                  </div>
                </div>
                <!-- 產品型號 -->
                <div class="d-flex pa-10px gray-100">
                  <h5 class="w-120px mr-10px">產品型號</h5>
                  <div class="flex-grow-1 flex-basis-0">
                    {{ item.model_name }}
                  </div>
                </div>
                <!-- 購買日期 -->
                <div class="d-flex pa-10px">
                  <h5 class="w-120px mr-10px">購買日期</h5>
                  <div class="flex-grow-1 flex-basis-0">
                    {{ item.purchased_date }}
                  </div>
                </div>
                <!-- 註冊日期 -->
                <div class="d-flex pa-10px gray-100">
                  <h5 class="w-120px mr-10px">註冊日期</h5>
                  <div class="flex-grow-1 flex-basis-0">
                    {{ item.created_at }}
                  </div>
                </div>
                <!-- 購買通路 -->
                <div class="d-flex pa-10px">
                  <h5 class="w-120px mr-10px">購買通路</h5>
                  <div class="flex-grow-1 flex-basis-0">
                    {{ item.channel }}
                  </div>
                </div>
                <!-- 國別/區域 -->
                <div class="d-flex pa-10px gray-100">
                  <h5 class="w-120px mr-10px">國別/區域</h5>
                  <div class="flex-grow-1 flex-basis-0">
                    {{ item.country }}
                  </div>
                </div>
                <!-- 購買證明圖片 -->
                <div class="d-flex pa-10px">
                  <h5 class="w-120px mr-10px">購買證明圖片</h5>
                  <div class="flex-grow-1 flex-basis-0">
                    <div
                      v-if="item.prove_pic"
                      class="bg-cover bg-center"
                      :style="{
                        width: '512px',
                        height: '298px',
                        'background-image': `url(${item.prove_pic})`,
                      }"
                    ></div>
                  </div>
                </div>
                <!-- 產品序號 -->
                <div class="d-flex pa-10px gray-100">
                  <h5 class="w-120px mr-10px">產品序號</h5>
                  <div class="flex-grow-1 flex-basis-0">
                    {{ item.sno }}
                  </div>
                </div>
                <!-- 產品數量 -->
                <div class="d-flex pa-10px">
                  <h5 class="w-120px mr-10px">產品數量</h5>
                  <div class="flex-grow-1 flex-basis-0">
                    {{ item.qty }}
                  </div>
                </div>
              </div>
            </template>
          </TableCollapse>
        </div>
      </div>

      <!-- table footer -->
      <Pagination
        @handleNextPreEvent="getMemberProductRegistrations(member.id)"
        model="productRegistration">
      </Pagination>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
// import SimpleSelectWithSearch from '@/components/Selection/SimpleSelectWithSearchInput.vue';
import TableCollapse from '@/components/TableCollapse.vue';
import Pagination from '@/components/Pagination.vue';

export default {
  components: {
    Pagination,
    // SimpleSelectWithSearch,
    TableCollapse,
  },
  created() {
    if (this.member !== null) {
      this.getMemberProductRegistrations(this.member.id);
    }
  },
  computed: {
    ...mapState('member', ['member']),
    ...mapState('productRegistration', [
      'productRegistrations',
      'filter',
    ]),
  },
  methods: {
    ...mapActions('productRegistration', {
      getMemberProductRegistrations: 'find',
    }),
  },
};
</script>

<style lang="scss" scoped>
.table {
  .col-product {
    width: 430px;
    margin-right: 20px;
  }
  .col-serial-number {
    width: 300px;
    margin-right: 20px;
  }
  .col-date-of-purchase {
    width: 75px;
    margin-right: 20px;
    text-align: right;
  }
  .col-date-of-register {
    width: 75px;
    text-align: right;
  }
}
</style>
